import React from 'react';
import {
  LineChart as RechartsLineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from 'recharts';

type WeeklyPoint = { date: string; value: number };

const LineChart: React.FC<{
  data: WeeklyPoint[];
  height?: string;
  stroke?: string;
}> = ({ data, height = 120, stroke = 'var(--primary)' }) => {
  return (
    <div style={{ width: '100%', height: '100%' }}>
      <ResponsiveContainer width="100%" height="100%">
        <RechartsLineChart
          data={data}
          margin={{ top: 10, right: 20, bottom: 10, left: 0 }}
        >
          {/* X-axis (date) */}
          <XAxis
            dataKey="date"
            stroke="#333"
            tick={{ fontSize: 12, fontFamily: 'Montserrat' }}
            axisLine
            tickLine
          />

          {/* Hide Y-axis */}
          <YAxis hide />

          {/* Optional: Add a light grid for better readability */}
          <CartesianGrid strokeDasharray="3 3" vertical={false} opacity={0.1} />

          {/* Tooltip shows value + date */}
          <Tooltip
            formatter={(value: number) => [`${value} visitors`, '']}
            labelFormatter={(label: string) => `${label}`}
            contentStyle={{
              fontFamily: 'Montserrat',
              fontSize: 12,
              borderRadius: '8px',
              border: `1px solid ${stroke}`,
            }}
          />

          {/* Line */}
          <Line
            type="monotone"
            dataKey="value"
            stroke={stroke}
            strokeWidth={3}
            dot={{ r: 4 }}
            activeDot={{ r: 6 }}
          />
        </RechartsLineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default LineChart;
